import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import Client from "./Client";
var ParentClient = /*#__PURE__*/function (_Client) {
  _inherits(ParentClient, _Client);
  var _super = _createSuper(ParentClient);
  function ParentClient() {
    var _this;
    _classCallCheck(this, ParentClient);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.methods = {
      handshake: function handshake() {
        _this.fulfillHandshake();
        var origin = window.location.origin;
        return {
          origin: origin
        };
      }
    };
    return _this;
  }
  _createClass(ParentClient, [{
    key: "open",
    value: function open(_ref) {
      var _this2 = this;
      var url = _ref.url,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? "PopupWindow" : _ref$name,
        _ref$features = _ref.features,
        features = _ref$features === void 0 ? {} : _ref$features;
      if (this.remoteWindow == null || this.remoteWindow.closed) {
        var result = new Promise(function (resolve) {
          _this2.fulfillHandshake = resolve;
        });
        this.targetOrigin = new URL(url).origin;
        this.listen();
        var featureString = formatFeatures(_objectSpread({}, calculatePosition(features), features));
        this.remoteWindow = window.open(url, name, featureString);
        return result;
      } else {
        this.remoteWindow.focus();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.disconnect();
      if (!(this.remoteWindow == null || this.remoteWindow.closed)) {
        this.remoteWindow.close();
      }
    }
  }, {
    key: "checkMessageAuthenticity",
    value: function checkMessageAuthenticity(event) {
      var source = event.source,
        origin = event.origin;
      return source === this.remoteWindow && origin === this.targetOrigin;
    }
  }, {
    key: "checkPostMessageAbility",
    value: function checkPostMessageAbility() {
      return this.remoteWindow != null && this.targetOrigin != null;
    }
  }]);
  return ParentClient;
}(Client);
export { ParentClient as default };
var calculatePosition = function calculatePosition(_ref2) {
  var height = _ref2.height,
    width = _ref2.width;
  var top = Number.isFinite(height) ? (window.screen.height - height) / 2 : undefined;
  var left = Number.isFinite(width) ? (window.screen.width - width) / 2 : undefined;
  return {
    top: top,
    left: left
  };
};
var formatFeatures = function formatFeatures(features) {
  return Object.entries(features).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      name = _ref4[0],
      value = _ref4[1];
    return Boolean(value);
  }).map(function (e) {
    return e.join("=");
  }).join(",");
};